(function () {

    const section = document.querySelector(`[id="product"]`);
    const product = JSON.parse(section.querySelector(".productJSON").textContent);

    // get orders sold
    fetch("https://cdn.vktry.com/order-count.json")
        .then(response => response.json())
        .then(response => {
            // show badge only if there are orders
            if (response.gold_order_count && response.gold_order_count > 0) {
                // format number with commas
                const ordersSoldCommas = response.gold_order_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                section.querySelector("#productSoldTxt").innerHTML = `${ordersSoldCommas} Sold <br> In Last 7 Days`;
                section.querySelector("#productSold").classList.add("active");
            }
        })


    // set up images swiper
    let productSwiper = new Swiper('#productSwiper', {
        slidesPerView: 1,
        spaceBetween: 50,
        autoHeight: true,
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productThumbsItem").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });


    // update active variant
    let formData = {
        items: []
    };

    // top cover is based off of sport (GOLD INSOLES)
    const sportToTopCover = {
        "Baseball/Softball": "B",
        "Basketball": "A",
        "Ultimate Frisbee": "B",
        "Boxing/Wrestling": "B",
        "Cheerleading": "C",
        "Fitness": "A",
        "Golf": "B",
        "Hiking": "A",
        "Football": "B",
        "Lacrosse": "B",
        "Rugby": "B",
        "Running": "A",
        "Soccer": "C",
        "Tennis/Pickleball": "A",
        "Track & Field": "C",
        "Volleyball": "A",
        "Walking": "A",
        "Other": "A",
    }

    // function to take variables from product options to a formdata item
    function getFormData(options, targetHandle) {
        // gender is a variant (make sure something is checked)
        let gender = options.gender ?? null;

        // sport is a property
        let sport = options.sport ?? null;

        // size is a variant
        let size = options.size ?? null;

        // weight is a property
        let weight = options.weight ?? null;

        // age is a property
        let age = options.age ?? null;

        // Determine product
        let targetProduct = goldWeightToProduct[weight];


        // Determine Top Cover
        let topCover = sportToTopCover[sport];

        // overrides
        // AFTER determining the product (based on the weight) we check on special cases
        // Note we do not touch the weight variable since it's used as a line item property
        // if they are Female and size 151-180, it changes the weight to pro level 3 from level 4 (we have another case for ages 50 and up so we exclude that)
        if (gender === "Female" && weight === "151 - 180lbs" && age !== "50 and Up") {
            targetProduct = goldWeightToProduct["121 - 150lbs"];
        }

        // if they are age 50 & up, we decrease the pro level by 1
        // if they are age 50 & up, we decrease the pro level by 1
        if (age === "50 and Up") {
            if (weight === "261lbs - Up") {
                targetProduct = goldWeightToProduct["231 - 260lbs"];
            } else if (weight === "231 - 260lbs" || weight === "211 - 230lbs") {
                targetProduct = goldWeightToProduct["181 - 210lbs"];
            } else if (weight === "181 - 210lbs" || weight === "151 - 180lbs") {
                targetProduct = goldWeightToProduct["121 - 150lbs"];
            } else if (weight === "121 - 150lbs") {
                targetProduct = goldWeightToProduct["100 - 120lbs"];
            } else {
                targetProduct = goldWeightToProduct["100 - 120lbs"];
            }
        }


        // find the correct variant based on the active options
        let activeVariant = null;
        for (let i = 0; i < targetProduct.variants.length; i++) {

            // here comes the tricky part, Shopfiy might have 5-5.5 OR 5.5-6 ending on the top cover however we're going to receive a size of 5, 5.5 or 6.
            // We need to do a split and find an exact match
            if (
                // size
                targetProduct.variants[i].option1.split("-").includes(size) &&
                // top cover
                targetProduct.variants[i].option2 === topCover &&
                // gender
                targetProduct.variants[i].option3 === gender
            ) {
                activeVariant = targetProduct.variants[i];
                break;
            }
        }


        // check if active variant is not found in any setup
        if (activeVariant == null) {
            return false;
        }

        // gather item
        let formData = {
            quantity: 1,
            id: activeVariant.id,
            properties: {
                "Age": age,
                "Sport": sport,
                "Weight": weight
            },
            available: activeVariant.available
        };

        // return
        return formData;

    }

    /**************
     Product Slider
     ***************/

        // enable swiper
    let productFormSwiper = new Swiper(".productFormSwiper", {
            allowTouchMove: false,
            autoHeight: true,
            spaceBetween: 30
        });


    // Progress bar
    productFormSwiper.on("slideChange", function () {
        // enable all buttons
        section.querySelectorAll('.productFormProgressCircleInner').forEach((element) => {
            element.disabled = false;
        });


        // update active progress bar circles
        section.querySelectorAll(".productFormProgressCircle")?.forEach((element, index) => {
            if (index <= productFormSwiper.activeIndex) {
                // we need to wait to add the active class
                // because the progress bar takes 300ms to animate
                setTimeout(() => {
                    element.classList.add("active");
                }, 100);
            } else {
                element.classList.remove("active");
            }
        });

        // update active progress bar lines
        section.querySelectorAll(".productFormProgressLineInner").forEach((element, index) => {
            element.classList.remove("active");
            if (index < productFormSwiper.activeIndex) {
                element.classList.add("active");
            }
        });

        // Progress bar button click slide change
        section.querySelectorAll('.productFormProgressCircle.active').forEach((element, index) => {
            element.addEventListener("click", function () {
                productFormSwiper.slideTo(index);
            });
        });

    });


    // Progress bar final slide edge cases
    // The final form is the last "slide" but isn't a swiper slide.
    // We need to add the active class to the final progress bar/circle when
    // the last swiper slide option is clicked, which is the weight group for platinum
    // and is the age group for silver/gold.
    let targetGroup = "age"


    section.querySelectorAll(`.productFormOptionSlideLabel[data-group='${targetGroup}']`)?.forEach(element => {
        element.addEventListener("click", function () {
            // add active class to all progress bar circles
            section.querySelectorAll(".productFormProgressCircle")?.forEach((element, index) => {
                element.classList.add("active");
            });
            // add active class to all progress bar lines
            section.querySelectorAll(".productFormProgressLineInner")?.forEach((element, index) => {
                element.classList.add("active");
            });

            // Since we're on the last slide, we need to disable the buttons
            section.querySelectorAll('.productFormProgressCircleInner').forEach((element) => {
                element.disabled = true;
            });
        });
    });


    // update active variant on click
    section.querySelectorAll(".productFormOptionSlideLabel").forEach(function (element) {
        element.addEventListener("click", function () {


            const group = this.dataset.group;
            const value = this.dataset.value;

            // remove active class from all items in this group
            section.querySelectorAll(`.productFormOptionSlideLabel[data-group="${group}"]`).forEach(element => element.classList.remove("active"));

            // add active class to this item
            this.classList.add("active");

            // go to next slide
            productFormSwiper.slideNext();


            // check if every group has an active item
            if (section.querySelectorAll(".productFormOptionSlide").length === section.querySelectorAll(".productFormOptionSlideLabel.active").length) {
                section.querySelector(".productFormWrap").classList.remove("active");
                section.querySelector(".productFormSwiper").classList.remove("active");
                section.querySelector(".productFormForm").classList.add("active");
            } else {
                section.querySelector(".productFormWrap").classList.add("active");
                section.querySelector(".productFormSwiper").classList.add("active");
                section.querySelector(".productFormForm").classList.remove("active");
                return;
            }

            // create options object
            let options = {};
            section.querySelectorAll(`.productFormOptionSlideLabel.active`).forEach(element => {
                options[element.dataset.group] = element.dataset.value;
            });

            // save options
            section.querySelector(".productFormReceipt").setAttribute("options", JSON.stringify(options));


            // update product
            updateProduct();
        });
    })

    // Clogs/Slides Title + Icons
    section.querySelectorAll('.productFormOptionSlideClogsItemValuesLabelInput.color').forEach(function (input) {
        input.addEventListener("click", function () {
            section.querySelector('.productFormOptionSlideClogsItemControlsTitleVal.color').textContent = this.value;

            let color = this.value;

            let iconMap = {
                Clogs: {
                    "Carbon Black": "https://cdn.shopify.com/s/files/1/0072/5568/7283/files/image_3_339c99fe-96d3-4243-ae96-9360c0497e76.png?v=1760397014&width=500",
                    "Cloud White": "https://cdn.shopify.com/s/files/1/0072/5568/7283/files/Render.bip.1681_d2c3befd-4cef-4a7d-b217-e3af07d0151f.png?v=1764094893&width=500"
                },
                Slides: {
                    "Carbon Black": "https://cdn.shopify.com/s/files/1/0072/5568/7283/files/2025_C3_Render_recovery_CLOG.1667_2.png?v=1760397119&width=500",
                    "Cloud White": "https://cdn.shopify.com/s/files/1/0072/5568/7283/files/2025_C3_Render_recovery_CLOG.1666_25369c37-7037-40e7-9b11-e205618c3330.png?v=1764094893&width=500"
                }
            };

            // update type selector images
            section.querySelector('.productFormOptionSlideClogsItemValuesLabelBodyIcon.clogs').src = iconMap["Clogs"][color];
            section.querySelector('.productFormOptionSlideClogsItemValuesLabelBodyIcon.slides').src = iconMap["Slides"][color];


        })
    })
    section.querySelectorAll('.productFormOptionSlideClogsItemValuesLabelInput.type').forEach(function (input) {
        input.addEventListener("click", function () {
            section.querySelector('.productFormOptionSlideClogsItemControlsTitleVal.type').textContent = this.dataset.title;
        })
    })

    // autoselect white clogs on load
    section.querySelector(`.productFormOptionSlideClogsItemValuesLabelInput[value='Cloud White']`)?.click();


    // Last slide is clogs size, show the final slide after they click
    section.querySelectorAll(`.productFormOptionSlideSizeLabelInput`)?.forEach(input => {
        input.addEventListener("change", function () {
            section.querySelector(".productFormWrap").classList.remove("active");
            section.querySelector(".productFormSwiper").classList.remove("active");
            section.querySelector(".productFormForm").classList.add("active");

            // create options object
            let options = {};
            section.querySelectorAll(`.productFormOptionSlideLabel.active`).forEach(element => {
                options[element.dataset.group] = element.dataset.value;
            });

            // save options
            section.querySelector(".productFormReceipt").setAttribute("options", JSON.stringify(options));


            // update product
            updateProduct();

        })
    });

    // back button
    section.querySelectorAll(".productFormSwiperNavBack").forEach(function (element) {
        element.addEventListener("click", function () {
            productFormSwiper.slidePrev();
        });
    });

    // next button
    section.querySelectorAll(".productFormSwiperNavNext").forEach(function (element) {
        element.addEventListener("click", function () {
            productFormSwiper.slideNext();
        });
    });


    // trigger close modal
    section.querySelectorAll(".productFormPairModal,.productFormPairModalCancel,.productFormPairModalExit").forEach(element => {
        element.addEventListener("click", function (e) {
            if (e.target === this) {
                section.querySelector(".productFormPairModal[open]").close();
            }
        })
    });

    // form input events
    section.querySelectorAll(".productFormPairModalLabelSelect").forEach(element => element.addEventListener("change", function () {
        // check if the entire form is ready
        let form = this.closest(".productFormPairModalContent");

        // check if all inputs are entered
        let ready = true;
        form.querySelectorAll(".productFormPairModalLabelSelect").forEach(input => {
            if (input.selectedIndex === 0) {
                ready = false;
            }
        });

        // update update button
        form.querySelector(".productFormPairModalUpdate").disabled = !ready;
    }));

    // update pair
    section.querySelectorAll(".productFormPairModalContent").forEach(element => {
        element.addEventListener("submit", function (e) {
            e.preventDefault();

            // save pair element
            let pairElement = section.querySelector(".productFormReceipt");

            // update options attribute only if the option isn't the initial one
            let insoleOptions = {};
            section.querySelector(".productFormPairModal").querySelectorAll(`.productFormPairModalLabelSelect.insole`).forEach(element => {
                if (!element.value.includes("Choose")) {
                    insoleOptions[element.getAttribute("name")] = element.value;
                }
            });

            pairElement.setAttribute("options", JSON.stringify(insoleOptions));

            // update clog options
            let editModal = section.querySelector('.productFormPairModal');

            let color = editModal.querySelector('.productFormPairModalLabelSelect.clogColor').value;
            let type = editModal.querySelector('.productFormPairModalLabelSelect.clogType').value;
            let size = editModal.querySelector('.productFormPairModalLabelSelect.clogSize').value;
            section.querySelectorAll('.productFormOptionSlideClogsItemValuesLabelInput.color').forEach(element => {
                if (element.value === color) {
                    element.checked = true
                }
            })
            section.querySelectorAll('.productFormOptionSlideClogsItemValuesLabelInput.type').forEach(element => {
                if (element.value === type) {
                    element.checked = true
                }
            })
            section.querySelectorAll('.productFormOptionSlideSizeLabelInput').forEach(element => {
                if (element.value === size) {
                    element.checked = true
                }
            })

            // close modal
            section.querySelector(".productFormPairModal[open]").close();

            updateProduct();
        });
    });

    // open edit
    section.querySelectorAll(".productFormActionEdit").forEach(element => {
        element.addEventListener("click", function () {
            // save pair element
            let pairElement = section.querySelector(".productFormReceipt");
            let editModal = section.querySelector('.productFormPairModal');

            // save option element
            let insoleOptions = pairElement.getAttribute("options");

            // open modal
            section.querySelector(".productFormPairModal").showModal();

            // select insole options
            let optionsParsed = JSON.parse(insoleOptions);
            editModal.querySelectorAll(`.productFormPairModalLabelSelect`).forEach(element => {
                element.value = optionsParsed[element.getAttribute("name")]
            });

            // select clog options
            let clogColor = section.querySelector('.productFormOptionSlideClogsItemValuesLabelInput.color:checked').value;
            let clogType = section.querySelector('.productFormOptionSlideClogsItemValuesLabelInput.type:checked').value;
            let clogSize = section.querySelector('.productFormOptionSlideSizeLabelInput:checked').value;
            editModal.querySelector('.productFormPairModalLabelSelect.clogColor').value = clogColor;
            editModal.querySelector('.productFormPairModalLabelSelect.clogType').value = clogType;
            editModal.querySelector('.productFormPairModalLabelSelect.clogSize').value = clogSize;

        })
    });

    // remove
    section.querySelectorAll(".productFormActionRemove").forEach(element => {
        element.addEventListener("click", function () {
            // save pair element
            let pairElement = section.querySelector(".productFormReceipt");

            // remove active and options
            pairElement.removeAttribute("options");

            section.querySelector(".productFormSwiper").classList.add("active");
            section.querySelector(".productFormForm").classList.remove("active");
            section.querySelectorAll(".productFormOptionSlideLabel.active").forEach(element => element.classList.remove("active"));

            // uncheck footwear size
            section.querySelector('.productFormOptionSlideSizeLabelInput:checked').checked = false;

            productFormSwiper.slideTo(0);

        });
    })


    function updateProduct() {
        // reset atc button (atc active)
        section.querySelector(".productFormATC").textContent = "Add To Cart";
        section.querySelector(".productFormATC").classList.add("active");
        section.querySelector(".productFormATC").classList.remove("disabled");
        section.querySelector(".productFormATC").classList.remove("message");

        // show terms
        // section.querySelector(".productFormTerms").classList.remove("active");

        // reset form data
        formData.items = [];

        // hide error message
        section.querySelector(".productFormATC").classList.remove("active");


        //  find the insoles product
        let options = JSON.parse(section.querySelector('.productFormReceipt').getAttribute("options"));
        let insoles = getFormData(options, product.handle);

        // find the clogs/slides product (footwear)
        let footwear = JSON.parse(section.querySelector('.productFormOptionSlideClogsItemValuesLabelInput.type:checked').value)
        let color = section.querySelector('.productFormOptionSlideClogsItemValuesLabelInput.color:checked').value;
        let size = section.querySelector('.productFormOptionSlideSizeLabelInput:checked').value;
        let gender = options.gender
        let footwearType = section.querySelector('.productFormOptionSlideClogsItemValuesLabelInput.type:checked').dataset.title;
        let clogVariant = null;
        let clogsOptions = [color, gender, size];
        clogVariant = footwear.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(clogsOptions)
        });

        // check if insoles/footwear is not found (variant can't be found)
        if (insoles === false || !insoles.available || !clogVariant || !clogVariant.available) {
            // hide atc button
            section.querySelector(".productFormATC").classList.add("active");

            // hide terms
            // section.querySelector(".productFormTerms").classList.add("active");

            let errorMsg = "Sorry, we don't offer a product that meets the selected options.";


            if (!insoles.available) {
                errorMsg = "Sorry, this product is currently out of stock.";
            }

            if (insoles === false) {
                errorMsg = "Unavailable — this selection is not currently part of our assortment";
            }


            section.querySelector('.productFormErrorMsg').textContent = errorMsg;

            // show error message
            section.querySelector(".productFormError").classList.add("active");

            // log request
            let formData = new FormData();
            formData.set("handle", product.handle);
            formData.set("options", JSON.stringify(options));
            fetch("https://api.vktry.com/variant-not-found.php", {
                method: "POST",
                body: formData
            });

            return;
        }


        // build the receipt
        let receiptElement = section.querySelector(".productFormReceipt");
        receiptElement.innerHTML = ``;

        // Insoles Data
        let insoleHTML = `
            <div class="productFormReceiptRow">
                <div class="productFormReceiptRowTitle bold">Insole:</div>
                <div class="productFormReceiptRowValue">Gold</div>
            </div>`

        for (const [key, value] of Object.entries(options)) {
            insoleHTML += `
                <div class="productFormReceiptRow">
                    <div class="productFormReceiptRowTitle">${key}:</div>
                    <div class="productFormReceiptRowValue">${value}</div>
                </div>
            `
        }
        insoleHTML += `<div class="productFormReceiptLine"></div>`

        // Clogs/Slides Data
        insoleHTML += `
            <div class="productFormReceiptRow">
                <div class="productFormReceiptRowTitle bold">Footwear:</div>
                <div class="productFormReceiptRowValue">${footwearType}</div>
            </div>
            <div class="productFormReceiptRow">
                <div class="productFormReceiptRowTitle">Color:</div>
                <div class="productFormReceiptRowValue">${color}</div>
            </div>
            <div class="productFormReceiptRow">
                <div class="productFormReceiptRowTitle">Footwear Size:</div>
                <div class="productFormReceiptRowValue">${size}</div>
            </div>`
        insoleHTML += `<div class="productFormReceiptLine"></div>`

        // Extras
        insoleHTML += `
            <div class="productFormReceiptRow">
                <div class="productFormReceiptRowTitle">Drawstring Bag:</div>
                <div class="productFormReceiptRowValue">Included</div>
            </div>
            <div class="productFormReceiptRow">
                <div class="productFormReceiptRowTitle">Footwear Cleaner:</div>
                <div class="productFormReceiptRowValue">Included</div>
            </div>`


        receiptElement.innerHTML = insoleHTML;


        // show atc
        section.querySelector(".productFormATC").classList.remove("active");

        // show terms
        // section.querySelector(".productFormTerms").classList.remove("active");

        // hide error message
        section.querySelector(".productFormError")?.classList.remove("active");

        // check for duplicates (id and property, if you check the entire object, the id won't match)
        for (let i = 0; i < formData.items.length; i++) {
            if (formData.items[i].id === item.id && JSON.stringify(formData.items[i].properties) === JSON.stringify(item.properties)) {
                formData.items[i].quantity++;
                return;
            }
        }

        // add insoles
        // add discount property to insoles
        insoles.properties._discount_kit = "luxury box v2";
        formData.items.push(insoles);
        // add clogs
        formData.items.push({
            quantity: 1,
            id: clogVariant.id,
            properties: {
                _discount_kit: "luxury box v2"
            }
        });
        // add extras (drawstring bag and shoe cleaner)
        formData.items.push({
            quantity: 1,
            id: 51675503427951, // drawstring bag
            properties: {
                _discount_kit: "luxury box v2"
            }
        });
        formData.items.push({
            quantity: 1,
            id: 52392856060271, // cleaner sponge
            properties: {
                _discount_kit: "luxury box v2"
            }
        });
    }

    // dynamic shoe size title
    section.querySelectorAll(".productFormOptionSlideLabel[data-group='gender']").forEach(element => {
        element.addEventListener("click", function () {
            section.querySelector('.productFormOptionSlideTitleGender').textContent = element.textContent;
        })
    })


    /**************
     Product ATC
     ***************/

    section.querySelector(".productFormATC").addEventListener("click", async function () {
        // add loading animation
        this.classList.add("loading");

        // add product
        await addProduct(formData);

        // stop loading
        this.classList.remove("loading");

        // open cart
        await openCart();
    });

    /********************************** Shoe Size **********************************/


    // open shoe size modal
    document.querySelectorAll(".openShoeSize").forEach(element => {
        element.addEventListener("click", function () {
            // Find the correct shoe size modal

            // The modal to open is based on the sport
            // Gold: Basketball, fitness, racquet sports, running, volleyball, walking/hiking, everyday
            // Black: Baseball, boxing, football, golf, lacrosse, rugby, ultimate frisbee, [NEW -> ]Cheerleading, Track, Soccer
            // Red: REMOVED and uses black now, was Cheerleading, Track, Soccer
            let sport = document.querySelector(`.productFormOptionSlideLabel.active[data-group="sport"]`)?.dataset?.value;

            if (sport === "Basketball" || sport === "Fitness" || sport === "Tennis/Pickleball" || sport === "Running" || sport === "Volleyball" || sport === "Hiking" || sport === "Walking" || sport === "Other") {
                document.querySelector('#shoeSizeGold').showModal();
            } else {
                document.querySelector('#shoeSizeBlack').showModal();
            }

            document.querySelector("body").classList.add("noScroll");

        })
    });

    // open clog size modal
    document.querySelectorAll(".upsellSize")?.forEach(element => {
        element.addEventListener("click", function () {
            document.querySelector('#shoeSizeClog').showModal();
            document.querySelector("body").classList.add("noScroll");
        })
    });

    //close shoe size event listener
    document.querySelectorAll(".shoeSizeContentClose")?.forEach(function (element) {
        element.addEventListener("click", async function () {
            let target = this.dataset.target;
            await closeSize(target);

        });
    });

    //close shoe size event listener
    document.querySelectorAll(".shoeSize")?.forEach(function (element) {
        element.addEventListener("click", async function (e) {
            if (e.target === this) {
                let target = element.id;
                await closeSize(target);

            }
        });
    });

    // close shoe size
    function closeSize(target) {
        document.querySelector(`#${target}`).close();
        document.querySelector("body").classList.remove("noScroll");
    }

    // register dialogs
    // wait for document to load first
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll("dialog.shoeSize")?.forEach(function (element) {
            dialogPolyfill.registerDialog(element);
        });
    });

    /**************
     Money Back
     ***************/

    // open moneyBack dialog
    document.querySelectorAll('.openMoneyBack').forEach(function (element) {
        element.addEventListener('click', function () {
            document.querySelector("#moneyBack").showModal();
            document.querySelector("body").classList.add("noScroll");
        });
    })

    // close moneyBack
    function closePopup() {
        document.querySelector("#moneyBack").close();
        document.querySelector("body").classList.remove("noScroll");
    }

    // close moneyBack event listener
    document.querySelectorAll(".moneyBackClose").forEach(function (element) {
        element.addEventListener("click", closePopup);
    });

    document.querySelector("#moneyBack").addEventListener("click", function (e) {
        if (e.target === this) {
            closePopup();
        }
    })

    // close event
    document.querySelector("#moneyBack").addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
    });

    // register dialog
    dialogPolyfill.registerDialog(document.querySelector("#moneyBack"));

    // setup Dropdowns
    section.querySelectorAll(".productInfoDropTop").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

}())


function isSizeInRange(currentSize, min, max) {
    const range = currentSize.split('-').map(parseFloat);
    const size = parseFloat(range[0]);
    return !isNaN(size) && size >= min && size <= max;
}